import { ScrollableWithGradients } from "@rentablo/components";
import { Card } from "@rentablo/components";
import { styled } from "@mui/material";
import { Account, useListAndSearchAllAccounts } from "@rentablo/api/apiv1";
import { useMemo } from "react";
import { ExtendedAccount } from "@features/depots/types";
import { getImportType } from "@features/depots/useAccountsByGroup";
import { useAccountsWithSyncRequired } from "@helpers";
import { DepotRow } from "./DepotRow";

const Container = styled(Card)<{ height?: string }>`
  padding: 0;
  box-shadow: none;
  height: 192px;
  position: relative;
  width: 100%;
  cursor: pointer;
  &:hover {
    box-shadow: ${({ theme }) => theme.shadows[4]};
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    height: 300px;
  }
`;

export const DepotsCard = () => {
  const { data } = useListAndSearchAllAccounts({
    type: ["01_depot"],
    // @ts-ignore
    order: ["name desc"],
  });
  const accounts = data?.accounts;
  const accountsWithSync = useAccountsWithSyncRequired(
    accounts ?? ([] as Account[])
  );

  const extendedAccounts = useMemo(
    () =>
      accountsWithSync.map<ExtendedAccount>((account) => ({
        ...account,
        importType: getImportType(account),
        lastChanged:
          account.timestamps?.updatedAt ?? account.timestamps?.createdAt,
      })),
    [accountsWithSync]
  );

  return (
    <Container>
      <ScrollableWithGradients
        recalculateDeps={[accounts]}
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        {extendedAccounts?.map((account, index) => (
          <DepotRow
            key={account.id}
            account={account}
            isLast={index === extendedAccounts.length - 1}
          />
        ))}
      </ScrollableWithGradients>
    </Container>
  );
};
